import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class ToastMsgService {

  settings: Settings;
  //apiEndPoint: string = Utils.getApiEndPoint(); // environment.APIEndpoint;
  duration = 5;


  constructor(
    private appSettings: AppSettings,    
    private translate: TranslateService,
    private snackBar: MatSnackBar) {

    this.settings = appSettings.settings;
  }

 

  showSuccess(message:string, action = '', config?:MatSnackBarConfig){
    config = config || new MatSnackBarConfig();
    config.duration = 4*1000;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass = "success";
    config.direction = this.settings.rtl ? 'rtl' : 'ltr';
    
    this.snackBar.open(message, action, config);
  }

  showError(message:string, action = '', config?:MatSnackBarConfig){
    config = config || new MatSnackBarConfig();
    config.duration = 4*1000;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass = "error";
    config.direction = this.settings.rtl ? 'rtl' : 'ltr';
    
    this.snackBar.open(message, action, config);
  }
}
